import styled from 'styled-components'

export const StyledSimilarVideosRoot = styled.div`
    display: flex;
    flex-direction: column;
`
